/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import Box from '@mui/material/Box'
import { EmtChip, EmtTypography, EmtIcon, useMobile } from 'emt-components-v2'
import { LightBox, TrueFalseContainer, TrueFalseItem } from '@/components/Profile/partials/StyledComponents'

type BadgeLabel = {
  '@type': string
  '@id': string
  label: string
  icon: string
}

type Badge = {
  '@type': string
  '@id': string
  position: number
  color: string
  label: BadgeLabel
  plainWidth: boolean
}

type BadgeGroup = {
  '@type': string
  '@id': string
  slug: string
  label: string
  badges: Badge[]
}

type ProfileService = {
  '@type': string
  '@id': string
  species: BadgeGroup
  weights: BadgeGroup
}

type Props = {
  data: ProfileService
}

export const Availabilities: React.FC<Props> = ({ data }) => {
  const [isMobile, isTablet] = useMobile()

  const species = data.species
  const weights = data.weights

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile || isTablet ? 'column' : 'row',
        gap: '24px',
      }}
    >
      {/* @ts-ignore */}
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {species?.label}
        </EmtTypography>
        <TrueFalseContainer>
          {species?.badges?.map((badge, k) => (
            <TrueFalseItem key={k}>
              <EmtChip color={badge.color} icon={<EmtIcon className={badge.label.icon} />} />
              <EmtTypography variant="body2" color="greyGradient.450">
                {badge.label.label}
              </EmtTypography>
            </TrueFalseItem>
          ))}
        </TrueFalseContainer>
      </LightBox>

      {/* @ts-ignore */}
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {weights?.label}
        </EmtTypography>
        <TrueFalseContainer>
          {weights?.badges?.map((badge, k) => (
            <TrueFalseItem key={k}>
              <EmtChip color={badge.color} icon={<EmtIcon className={badge.label.icon} />} />
              <EmtTypography variant="body2" color="greyGradient.450">
                {badge.label.label}
              </EmtTypography>
            </TrueFalseItem>
          ))}
        </TrueFalseContainer>
      </LightBox>
    </Box>
  )
}
